var React = require('react');

function Two (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","fill":"#1DB4FF","d":"M54.77 26.98c1-1.1.91-2.8-.21-3.77L29.77 1.6a3.1 3.1 0 00-4.02.04L.88 24.36c-.66 1-.6 3.17-.12 3.77l.62.64c1.04 1.08 3.51 1.2 3.73.81l1.86-2.18v24.28a2.7 2.7 0 002.7 2.7h9.7c1.5 0 3.39-1.2 3.39-2.7V34.7h11.68v17c-.02 1.48 1.05 2.69 2.54 2.69h10.27c1.5 0 2.7-1.21 2.7-2.7V27.74l1.15 1c.63.56 2.53.11 3.58-.99l.1-.77z"}));
}

Two.defaultProps = {"viewBox":"0 0 56 55","height":"100%","width":"100%"};

module.exports = Two;

Two.default = Two;
